const BYDAY_NAMES: Record<string, string> = {
  MO: 'Mon',
  TU: 'Tue',
  WE: 'Wed',
  TH: 'Thu',
  FR: 'Fri',
  SA: 'Sat',
  SU: 'Sun',
};

export function formatRrule(rrule: string | null): string {
  if (!rrule) return '';
  const parts = Object.fromEntries(
    rrule.split(';').map((kv) => {
      const [k, v] = kv.split('=');
      return [k ?? '', v ?? ''];
    })
  );
  const freq = parts['FREQ'];
  const byday = parts['BYDAY'];
  const interval = parts['INTERVAL'];
  const bymonth = parts['BYMONTH'];
  const bymonthday = parts['BYMONTHDAY'];

  if (freq === 'YEARLY' && bymonth && bymonthday) {
    return `Every ${bymonthday.padStart(2, '0')}/${bymonth.padStart(2, '0')}`;
  }

  if (freq === 'MONTHLY' && bymonthday && !bymonth) {
    const d = parseInt(bymonthday, 10);
    const suffix = d === 1 ? 'st' : d === 2 ? 'nd' : d === 3 ? 'rd' : 'th';
    return `Every ${d}${suffix}`;
  }

  if (freq === 'MONTHLY' && byday) {
    const m = byday.match(/^(-?\d+)([A-Z]{2})$/);
    if (m) {
      const n = parseInt(m[1]!, 10);
      const day = BYDAY_NAMES[m[2]!] ?? m[2];
      const label =
        n === -1 ? 'last' :
        n === 1 ? '1st' :
        n === 2 ? '2nd' :
        n === 3 ? '3rd' :
        `${n}th`;
      return `Every ${label} ${day}`;
    }
  }

  const unit: Record<string, [string, string]> = {
    DAILY: ['day', 'days'],
    WEEKLY: ['week', 'weeks'],
    MONTHLY: ['month', 'months'],
    YEARLY: ['year', 'years'],
  };

  if (interval && freq && unit[freq]) {
    const n = parseInt(interval, 10);
    const [sing, plur] = unit[freq]!;
    return `Every ${n} ${n === 1 ? sing : plur}`;
  }

  if (freq === 'DAILY') return 'Daily';
  if (freq === 'MONTHLY') return 'Monthly';
  if (freq === 'YEARLY') return 'Yearly';
  if (freq === 'WEEKLY') {
    if (!byday) return 'Weekly';
    if (byday === 'MO,TU,WE,TH,FR') return 'Weekdays';
    if (byday === 'SA,SU' || byday === 'SU,SA') return 'Weekends';
    const days = byday
      .split(',')
      .map((d) => BYDAY_NAMES[d] ?? d)
      .join(', ');
    return days;
  }
  return rrule;
}
